import { getEnvironment } from '@sunrun/sales-experience-shared';

const getUrls = () => {
  const env = getEnvironment();
  return env === 'production'
    ? {
        splatBaseUrl: 'https://go.sunrun.com',
        oneBaseUrl: 'https://sunrunone.com',
        salesforceBaseUrl: 'https://sunrun.my.salesforce.com',
        sfPartnerBaseUrl: 'https://sunrun.my.site.com',
      }
    : {
        splatBaseUrl: 'https://majstg-go.sunrun.com',
        oneBaseUrl: 'https://staging.sunrunone.com',
        salesforceBaseUrl: 'https://sunrun--uat.sandbox.my.salesforce.com',
        sfPartnerBaseUrl: 'https://sunrun--uat.sandbox.my.site.com',
      };
};

export { getUrls };
